/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ClientIntake {
    angular.module("meevo.plugins.clientIntake", []);
}